<template>
    <div class="page-default">
        <div class="box-content">
            <slot class="box-content-inner"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Default'
    };
</script>


// WEBPACK FOOTER //
// Default.vue?6ee322d6